import React from 'react';
import { useTranslation } from 'react-i18next';

const EpisodeCard = ({ episode, seasonNumber, onToggleWatched }) => {
  const { t } = useTranslation();
  const TMDB_IMAGE_BASE = 'https://image.tmdb.org/t/p/w300';
  const hasImage = episode.still_path;
  const imageUrl = hasImage ? `${TMDB_IMAGE_BASE}${episode.still_path}` : null;

  return (
    <div
      className={`episode-card ${episode.watched ? 'watched' : ''}`}
      onClick={onToggleWatched}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onToggleWatched();
        }
      }}
      aria-label={t('episodes.episodeAria', {
        number: episode.episode_number,
        name: episode.name ? `: ${episode.name}` : '',
        status: episode.watched ? t('episodes.watched') : t('episodes.notWatched')
      })}
    >
      {hasImage ? (
        <img
          src={imageUrl}
          alt={`${t('episodes.episode')} ${episode.episode_number}${episode.name ? `: ${episode.name}` : ''}`}
          className="episode-card-image"
          loading="lazy"
        />
      ) : (
        <div className="episode-card-placeholder">
          {episode.episode_number}
        </div>
      )}

      <div className="episode-card-number">
        {episode.episode_number}
      </div>

      {episode.name && (
        <div className="episode-card-name">
          {episode.name}
        </div>
      )}

      <div className="episode-card-watched">
        <div className="episode-card-checkmark">
          ✓
        </div>
      </div>
    </div>
  );
};

export default EpisodeCard;
